export function createGenericConversionRow(row?: any) {
  return {
    spend: row?.spend ?? null,
    imprs: row?.impressions ?? null,
    visits: row?.visits ?? null,
    newVisits: row?.new_visits ?? null,

    pVisits: 0,
    pTxns: 0,
    pRev: 0,

    convs: [],
    goals: [],

    extraRev_to_30: row?.extraRev_to_30 ?? null,
    extraRev_to_60: row?.extraRev_to_60 ?? null,
    extraRev_to_90: row?.extraRev_to_90 ?? null,

    extraTxns_to_30: row?.extraTxns_to_30 ?? null,
    extraTxns_to_60: row?.extraTxns_to_60 ?? null,
    extraTxns_to_90: row?.extraTxns_to_90 ?? null,

    metaTotalPurchases1DClick: row?.total_purchases_1d_click ?? null,
    metaTotalPurchases1DView: row?.total_purchases_1d_view ?? null,
    metaTotalPurchases7DClick: row?.total_purchases_7d_click ?? null,
    metaTotalPurchases7DClick1DView:
      row?.total_purchases_7d_click_1d_view ?? null,
    metaShopPurchases1DClick: row?.meta_shop_purchases_1d_click ?? null,
    metaShopPurchases7DClick: row?.meta_shop_purchases_7d_click ?? null,
    metaShopPurchases7DClick1DView:
      row?.meta_shop_purchases_7d_click_1d_view ?? null,
    metaOffsitePixelPurchases1DClick:
      row?.offsite_pixel_purchases_1d_click ?? null,
    metaOffsitePixelPurchases7DClick:
      row?.offsite_pixel_purchases_7d_click ?? null,
    metaOffsitePixelPurchases7DClick1DView:
      row?.offsite_pixel_purchases_7d_click_1d_view ?? null,
    metaTotalRevenue1DClick: row?.total_revenue_1d_click ?? null,
    metaTotalRevenue7DClick: row?.total_revenue_7d_click ?? null,
    metaTotalRevenue7DClick1DView: row?.total_revenue_7d_click_1d_view ?? null,
    metaShopRevenue1DClick: row?.meta_shop_revenue_1d_click ?? null,
    metaShopRevenue7DClick: row?.meta_shop_revenue_7d_click ?? null,
    metaShopRevenue7DClick1DView:
      row?.meta_shop_revenue_7d_click_1d_view ?? null,
    metaOffsitePixelRevenue1DClick: row?.offsite_pixel_revenue_1d_click ?? null,
    metaOffsitePixelRevenue7DClick: row?.offsite_pixel_revenue_7d_click ?? null,
    metaOffsitePixelRevenue7DClick1DView:
      row?.offsite_pixel_revenue_7d_click_1d_view ?? null,
    metaImprs: row?.imprs ?? null,
    metaVideoPlayActions7DClick1DView:
      row?.video_play_actions_7d_click_1d_view ?? null,
    metaVideoPlayActions1DView: row?.video_play_actions_1d_view ?? null,
    metaVideoThruplayWatchedActions7DClick1DView:
      row?.video_thruplay_watched_actions_7d_click_1d_view ?? null,
    metaVideoThruplayWatchedActions1DView:
      row?.video_thruplay_watched_actions_1d_view ?? null,
    meta3SVideoViewsDefault: row?.meta_3S_video_views_default ?? null,
    metaOfflineRevenue1DClick: row?.meta_offline_revenue_1d_click ?? null,
    metaOfflineRevenue7DClick: row?.meta_offline_revenue_7d_click ?? null,
    metaOfflineRevenue7DClick1DView:
      row?.meta_offline_revenue_7d_click_1d_view ?? null,
    metaMobileAppRevenue1DClick: row?.meta_mobile_app_revenue_1d_click ?? null,
    metaMobileAppRevenue7DClick: row?.meta_mobile_app_revenue_7d_click ?? null,
    metaMobileAppRevenue7DClick1DView:
      row?.meta_mobile_app_revenue_7d_click_1d_view ?? null,
    metaOfflinePurchases1DClick: row?.meta_offline_purchases_1d_click ?? null,
    metaOfflinePurchases7DClick: row?.meta_offline_purchases_7d_click ?? null,
    metaOfflinePurchases7DClick1DView:
      row?.meta_offline_purchases_7d_click_1d_view ?? null,
    metaMobileAppPurchases1DClick:
      row?.meta_mobile_app_purchases_1d_click ?? null,
    metaMobileAppPurchases7DClick:
      row?.meta_mobile_app_purchases_7d_click ?? null,
    metaMobileAppPurchases7DClick1DView:
      row?.meta_mobile_app_purchases_7d_click_1d_view ?? null,

    metaShopPurchases1DView: row?.meta_shop_purchases_1d_view,
    metaOfflinePurchases1DView: row?.meta_offline_purchases_1d_view,
    metaMobileAppPurchases1DView: row?.meta_mobile_app_purchases_1d_view,
    metaOffsitePixelPurchases1DView: row?.offsite_pixel_purchases_1d_view,
    metaTotalRevenue1DView: row?.total_revenue_1d_view,
    metaShopRevenue1DView: row?.meta_shop_revenue_1d_view,
    metaOfflineRevenue1DView: row?.meta_offline_revenue_1d_view,
    metaOffsitePixelRevenue1DView: row?.offsite_pixel_revenue_1d_view,
    metaMobileAppRevenue1DView: row?.meta_mobile_app_revenue_1d_view,
    metaSpend: row?.meta_spend,

    googleAllConversions: row?.google_all_conversions,
    googleAllConversionsValue: row?.google_all_conversions_value,
    googleConversions: row?.google_conversions,
    googleConversionsValue: row?.google_conversions_value,
    googleImpressions: row?.google_impressions,
    googleClicks: row?.google_clicks,
    googleVideoViews: row?.google_video_views,
    googleViewThroughConversions: row?.google_view_through_conversions,
    googleSpend: row?.google_spend,

    tiktokVideoViews: row?.tiktok_video_views ?? null,
    tiktokVideoViews2s: row?.tiktok_video_views_2s ?? null,
    tiktokVideoViews6s: row?.tiktok_video_views_6s ?? null,
    tiktokVideoViewsP100: row?.tiktok_video_views_P100 ?? null,
    tiktokVideoViewsP75: row?.tiktok_video_views_P75 ?? null,
    tiktokVideoViewsP50: row?.tiktok_video_views_P50 ?? null,
    tiktokVideoViewsP25: row?.tiktok_video_views_P25 ?? null,
    tiktokImprs: row?.tiktok_imprs ?? null,
    tiktokLikes: row?.tiktok_likes ?? null,
    tiktokClicks: row?.tiktok_clicks ?? null,
    tiktokCompletePayment: row?.tiktok_complete_payment ?? null,
    tiktokTotalCompletePayment: row?.tiktok_total_complete_payment ?? null,
    tiktokEngagements: row?.tiktok_engagements ?? null,
    tiktokSpend: row?.tiktok_spend ?? null,
    tiktokGMVNetCost: row?.tiktok_gmv_net_cost ?? null,
    tiktokGMVCostPerOrder: row?.tiktok_gmv_cost_per_order ?? null,
    tiktokGMVGrossRevenue: row?.tiktok_gmv_gross_revenue ?? null,
    tiktokGMVCostPerLiveView: row?.tiktok_gmv_cost_per_live_view ?? null,
    tiktokGMVCostPer10SecondLiveView:
      row?.tiktok_gmv_cost_per_10_second_live_view ?? null,
    tiktokGMVOrders: row?.tiktok_gmv_orders ?? null,

    tiktokGMVLiveViews: row?.tiktok_gmv_live_views ?? null,
    tiktokGMVTenSecondLiveViews: row?.tiktok_gmv_ten_second_live_views ?? null,
    tiktokGMVLiveFollows: row?.tiktok_gmv_live_follows ?? null,

    snapchatSpend: row?.snapchat_spend ?? null,
    snapchatPaidImpressions: row?.snapchat_paid_impressions ?? null,
    snapchatEarnedImpressions: row?.snapchat_earned_impressions ?? null,
    snapchatTotalImpressions: row?.snapchat_total_impressions ?? null,
    snapchatSwipes: row?.snapchat_swipes ?? null,
    snapchatProfileClicks: row?.snapchat_profile_clicks ?? null,
    snapchatVideoViews: row?.snapchat_video_views ?? null,
    snapchatVideoViewsTimeBased: row?.snapchat_video_views_time_based ?? null,
    snapchatVideoViews15S: row?.snapchat_video_views_15s ?? null,
    snapchatQuartile1: row?.snapchat_quartile_1 ?? null,
    snapchatQuartile2: row?.snapchat_quartile_2 ?? null,
    snapchatQuartile3: row?.snapchat_quartile_3 ?? null,
    snapchatViewCompletion: row?.snapchat_view_completion ?? null,
    snapchatAttachmentTotalViewTimeMillis:
      row?.snapchat_attachment_total_view_time_millis ?? null,
    snapchatRevenueMicrocurrency: row?.snapchat_revenue_microcurrency ?? null,
    snapchatTransactions: row?.snapchat_transactions ?? null,

    metaPostEngagement1DView: row?.meta_post_engagement_1d_view,
    metaPostEngagement1DClick: row?.meta_post_engagement_1d_click,
    metaPostEngagement7DClick: row?.meta_post_engagement_7d_click,
    metaPostEngagement7DClick1DView: row?.meta_post_engagement_7d_click_1d_view,
    metaPostEngagementDefault: row?.meta_post_engagement_default,
    metaPageEngagement1DView: row?.meta_page_engagement_1d_view,
    metaPageEngagement1DClick: row?.meta_page_engagement_1d_click,
    metaPageEngagement7DClick: row?.meta_page_engagement_7d_click,
    metaPageEngagement7DClick1DView: row?.meta_page_engagement_7d_click_1d_view,
    metaPageEngagementDefault: row?.meta_page_engagement_default,
    metaPageLikes1DView: row?.meta_page_likes_1d_view,
    metaPageLikes1DClick: row?.meta_page_likes_1d_click,
    metaPageLikes7DClick: row?.meta_page_likes_7d_click,
    metaPageLikes7DClick1DView: row?.meta_page_likes_7d_click_1d_view,
    metaPageLikesDefault: row?.meta_page_likes_default,
    metaVideoContinuous2SecWatchedActions:
      row?.meta_video_continuous_2_sec_watched_actions,

    metaLinkClicks: row?.meta_link_clicks,
    metaOutboundClicks: row?.meta_outbound_clicks,

    meta3SVideoViews1DClick: row?.meta_3S_video_views_1d_click,
    meta3SVideoViews7DClick: row?.meta_3S_video_views_7d_click,
    meta3SVideoViews7DClick1DView: row?.meta_3S_video_views_7d_click_1d_view,
    metaVideoP25Watched: row?.meta_video_p25_watched,
    metaVideoP50Watched: row?.meta_video_p50_watched,
    metaVideoP75Watched: row?.meta_video_p75_watched,
    metaVideoP95Watched: row?.meta_video_p95_watched,
    metaVideoP100Watched: row?.meta_video_p100_watched,

    pinterestCheckoutConversions: row?.pinterest_checkout_conversions,
    pinterestCheckoutOrderValue: row?.pinterest_checkout_order_value,
    pinterestPageVisitConversions: row?.pinterest_page_visit_conversions,
    pinterestAddToCartClickConversions:
      row?.pinterest_add_to_cart_click_conversions,
    pinterestPaidImpressions: row?.pinterest_paid_impressions,
    pinterestPaidEngagements: row?.pinterest_paid_engagements,
    pinterestPaidPinClicks: row?.pinterest_paid_pin_clicks,
    pinterestPaidSaves: row?.pinterest_paid_saves,
    pinterestPaidIdeaPinProductTagVisit:
      row?.pinterest_paid_idea_pin_product_tag_visit,
    pinterestSpendInAccountCurrency: row?.pinterest_spend_in_account_currency,
    pinterestPaidVideoViews: row?.pinterest_paid_video_views,
    pinterestPaid3SecVideoViews: row?.pinterest_paid_3sec_video_views,
    pinterestPaidVideoPlayedAt25: row?.pinterest_paid_video_played_at_25,
    pinterestPaidVideoPlayedAt50: row?.pinterest_paid_video_played_at_50,
    pinterestPaidVideoPlayedAt75: row?.pinterest_paid_video_played_at_75,
    pinterestPaidVideoPlayedAt95: row?.pinterest_paid_video_played_at_95,
    pinterestPaidVideoPlayedAt100: row?.pinterest_paid_video_played_at_100,
    pinterestPaidVideoStarts: row?.pinterest_paid_video_starts,

    twitterClicks: row?.twitter_clicks,
    twitterAppClicks: row?.twitter_app_clicks,
    twitterLikes: row?.twitter_likes,
    twitterFollows: row?.twitter_follows,
    twitterRetweets: row?.twitter_retweets,
    twitterUnfollows: row?.twitter_unfollows,
    twitterEngagements: row?.twitter_engagements,
    twitterReplies: row?.twitter_replies,
    twitterUrlClicks: row?.twitter_url_clicks,
    tradedeskImpressions: row?.tradedesk_impressions,
  };
}
